<template>
    <layout-main :banner="banner" subtitle="特殊患者防走失系统">
        <template v-slot:content>
            <p class="text">特殊患者防走失系统是南京迪孚网络科技有限公司围绕RFID技术推出的一系列产品以及应用，定位系统解决方案基于第二代红外和有源RFID组合技术，系统与其他纯粹基于RFID技术的方案有独特优势。针对特殊患者定位管理设计，满足医院对失能老人、精神病患者、传染性患者等患者定位管理需求，定位精准有效，多种告警模式。有效防止患者迷路、擅自离院、隐藏等突发事件的发生，减轻医院的监管压力，提高医护人员的工作效率。</p>
            <img src="@/assets/beLost/image1.png" alt="" class="image1">
            <div class="title weight"> 产品特征 </div>
            <p class="text weight">· 防拆腕带的设计，佩戴安全舒适，异常拆除行为报警</p>
            <p class="text weight">· 实时显示位置信息，可追寻历史轨迹</p>
            <p class="text weight">· 无需充电，电池续航持续1年以上</p>
           
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/beLost/banner.png'
export default {
    components: {
        layoutMain,
        
    },
    data () {
        return {
            banner: banner
        }
    }
}
</script>
<style lang="scss" scoped>
  .weight{
      font-weight: 600;
      line-height: 3 !important;
  }
  .title{ 
      text-indent: 1.5em;
      font-size: 25px;
      text-align: left;
      margin: 20px 0;
  }
  .text{
      line-height: 2;
  }
  .image1{
      width: 100%;
      margin: 50px 0;
  }
</style>
